namespace TabAurous.Inventory {
    export interface SKUSplittingDetailsForm {
        LedgerName: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        NewProductId: Serenity.StringEditor;
        NewProductCode: Serenity.StringEditor;
        DesignId: Serenity.ServiceLookupEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        StampId: Serenity.LookupEditor;
        HUID: Serenity.StringEditor;
        NewSKU: Serenity.IntegerEditor;
        NewGrossWeight: Serenity.DecimalEditor;
        NewNetWeight: Serenity.DecimalEditor;
        NewStoneWeight: Serenity.DecimalEditor;
        GenerateSKU: ButtonEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        AllotedPieces: Serenity.IntegerEditor;
        AllotedWeight: Serenity.DecimalEditor;
        AllotedNetWeight: Serenity.DecimalEditor;
        BalancePieces: Serenity.IntegerEditor;
        BalanceWeight: Serenity.DecimalEditor;
        BalanceNetWeight: Serenity.DecimalEditor;
        ItemsDetails: SKUSplittingItemsEditor;
    }

    export class SKUSplittingDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKUSplittingDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKUSplittingDetailsForm.init)  {
                SKUSplittingDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = CommonProductSizeLookup;
                var w6 = s.IntegerEditor;
                var w7 = s.DecimalEditor;
                var w8 = ButtonEditor;
                var w9 = SKUSplittingItemsEditor;

                Q.initFormType(SKUSplittingDetailsForm, [
                    'LedgerName', w0,
                    'ProductCode', w0,
                    'NewProductId', w0,
                    'NewProductCode', w0,
                    'DesignId', w1,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'ProductSizeId', w5,
                    'StampId', w2,
                    'HUID', w0,
                    'NewSKU', w6,
                    'NewGrossWeight', w7,
                    'NewNetWeight', w7,
                    'NewStoneWeight', w7,
                    'GenerateSKU', w8,
                    'Pieces', w6,
                    'Weight', w7,
                    'NetWeight', w7,
                    'AllotedPieces', w6,
                    'AllotedWeight', w7,
                    'AllotedNetWeight', w7,
                    'BalancePieces', w6,
                    'BalanceWeight', w7,
                    'BalanceNetWeight', w7,
                    'ItemsDetails', w9
                ]);
            }
        }
    }
}
